<div class="agpr-formField agpr-linkStyleField-container">
    <div class="agpr-formField-heading">
        <span class="agpr-formField-headingLabel">
            {{ field.label | localize }}
        </span>
    </div>
    <div class="agpr-formField agpr-linkStyleField-content">
        <div class="agpr-linkStyleField-header">
            {{ 'PageBuilder.formField.styles.display' | localize}}
        </div>
        <div
            class="agpr-linkStyleField-row"
            role="radiogroup"
            [attr.aria-label]="'PageBuilder.formField.tooltip.alignment' | localize"
        >
            <agpr-radio
                class="agpr-linkStyleField-button agpr-linkStyleField-button--first"
                [id]="id + '.leftRadioButton'"
                name="alignment-{{id}}"
                [value]="fontAlignmentEnum.left"
                [(ngModel)]="value.alignment"
                [pTooltip]="'PageBuilder.formField.tooltip.alignLeft' | localize"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-left'"
                (onClick)="setStyle(fontAlignmentEnum.left, 'alignment')"
                [hiddenLabel]="'PageBuilder.formField.tooltip.alignLeft'"
            ></agpr-radio>
            <agpr-radio
                class="agpr-linkStyleField-button"
                [id]="id + '.centerRadioButton'"
                name="alignment-{{id}}"
                [value]="fontAlignmentEnum.center"
                [(ngModel)]="value.alignment"
                [pTooltip]="'PageBuilder.formField.tooltip.alignCenter' | localize"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-center-horizontal'"
                (onClick)="setStyle(fontAlignmentEnum.center, 'alignment')"
                [hiddenLabel]="'PageBuilder.formField.tooltip.alignCenter'"
            ></agpr-radio>
            <agpr-radio
                class="agpr-linkStyleField-button"
                [id]="id + '.rightRadioButton'"
                name="alignment-{{id}}"
                [value]="fontAlignmentEnum.right"
                [(ngModel)]="value.alignment"
                [pTooltip]="'PageBuilder.formField.tooltip.alignRight' | localize"
                [style]="radioTypesEnum.button"
                [icon]="'fa-regular fa-duotone fa-objects-align-right'"
                (onClick)="setStyle(fontAlignmentEnum.right, 'alignment')"
                [hiddenLabel]="'PageBuilder.formField.tooltip.alignRight'"
            ></agpr-radio>
        </div>
        <div class="agpr-linkStyleField-header">
            {{ 'PageBuilder.formField.styles.linkText' | localize}}
        </div>
        <div class="agpr-linkStyleField-row agpr-linkStyleField-row--last" role="group" [attr.aria-label]="'PageBuilder.formField.styles.linkText' | localize">
            <div
                [pTooltip]="'PageBuilder.formField.tooltip.fontSize' | localize"
                class="agpr-linkStyleField-fontSize"
            >
                <div class="agpr-linkStyleField-fontSizeIcon">
                    <i
                        class="agpr-i-font-size"
                        aria-hidden="true"
                    ></i>
                </div>
                <agpr-dropdown-field
                    class="agpr-linkStyleField-fontSizeDropdown"
                    [id]="id + '.fontSizeDropdown'"
                    [value]="value.fontSize"
                    [field]="fontSizeField"
                    (changes)="setStyle($event, fontSizeField.property)"
                >
                </agpr-dropdown-field>
            </div>
            <agpr-checkbox
                class="agpr-linkStyleField-button"
                [id]="id + '.bold'"
                [(ngModel)]="value.bold"
                [tooltip]="'PageBuilder.formField.tooltip.bold'"
                [binary]="true"
                [style]="checkboxTypesEnum.button"
                [icon]="'agpr-i-font-bold'"
                (onChange)="setStyle($event, 'bold')"
            >
            </agpr-checkbox>
            <agpr-checkbox
                class="agpr-linkStyleField-button"
                [id]="id + '.italics'"
                [(ngModel)]="value.italics"
                [tooltip]="'PageBuilder.formField.tooltip.italics'"
                [binary]="true"
                [style]="checkboxTypesEnum.button"
                [icon]="'agpr-i-font-italic'"
                (onChange)="setStyle($event, 'italics')"
            >
            </agpr-checkbox>
            <agpr-checkbox
                class="agpr-linkStyleField-button"
                [id]="id + '.underlined'"
                [(ngModel)]="value.underlined"
                [tooltip]="'PageBuilder.formField.tooltip.underline'"
                [binary]="true"
                [style]="checkboxTypesEnum.button"
                [icon]="'agpr-i-font-underline'"
                (onChange)="setStyle($event, 'underlined')"
            >
            </agpr-checkbox>
        </div>
    </div>
</div>
